(function () {
  const activeTabState = {}; // sectionId -> index

  function getSectionKey(root) {
    return root.dataset.section || root.id || 'default';
  }

  function rememberActiveIndex(root, index) {
    const key = getSectionKey(root);
    activeTabState[key] = index;
    try {
      localStorage.setItem('variantTabActive-' + key, String(index));
    } catch (e) {}
  }

  function readRememberedIndex(root, max) {
    const key = getSectionKey(root);

    if (activeTabState[key] != null && activeTabState[key] < max) {
      return activeTabState[key];
    }

    try {
      const stored = localStorage.getItem('variantTabActive-' + key);
      if (stored != null) {
        const idx = parseInt(stored, 10);
        if (!isNaN(idx) && idx >= 0 && idx < max) {
          activeTabState[key] = idx;
          return idx;
        }
      }
    } catch (e) {}

    return null;
  }

  function getSelectedTextForIndex(root, index) {
    const panels = Array.from(root.querySelectorAll('[data-fieldset-index]'));
    const panel = panels.find(
      (p) => Number(p.dataset.fieldsetIndex) === index
    );
    if (!panel) return '';

    // 1) radio swatches / buttons
    const checkedRadio = panel.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      const label = panel.querySelector(`label[for="${checkedRadio.id}"]`);
      if (label) return label.textContent.trim();
    }

    // 2) dropdown
    const selectEl = panel.querySelector('select');
    if (selectEl && selectEl.options.length) {
      return selectEl.options[selectEl.selectedIndex].textContent.trim();
    }

    // 3) Dawn-style [data-selected-value]
    const dataSelected = panel.querySelector('[data-selected-value]');
    if (dataSelected) return dataSelected.textContent.trim();

    return '';
  }

  function updateTabLabel(root, index) {
    const tabs = Array.from(root.querySelectorAll('.variant-tab'));
    const tab = tabs.find(
      (t) => Number(t.dataset.optionIndex) === index
    );
    if (!tab) return;

    const text = getSelectedTextForIndex(root, index);
    const labelEl = tab.querySelector('.selected-option');
    if (labelEl && text) {
      labelEl.textContent = text;
    }
  }

  function updateAllTabLabels(root) {
    const panels = Array.from(root.querySelectorAll('[data-fieldset-index]'));
    const uniqueIndexes = Array.from(
      new Set(panels.map((p) => Number(p.dataset.fieldsetIndex)))
    );
    uniqueIndexes.forEach((i) => updateTabLabel(root, i));
  }

  // 🔹 Extra buttons per active tab (Size / Storage / Base / Headboard Height)
  function updateExtraButtonsForRoot(root, index) {
    // Hide all variant-extra-button in this root
    const extraButtons = root.querySelectorAll('.variant-extra-button');
    extraButtons.forEach((btn) => {
      btn.style.display = 'none';
    });

    const tabs = Array.from(root.querySelectorAll('.variant-tab'));
    const activeTab = tabs[index];
    if (!activeTab) return;

    const labelNode =
      activeTab.querySelector('.variant-tab-label') ||
      activeTab.querySelector('p') ||
      activeTab;
    const tabLabel = labelNode.textContent.trim().toLowerCase();

    if (tabLabel === 'size') {
      const sizeBtn = root.querySelector('.view-size-button-wrapper');
      if (sizeBtn) sizeBtn.style.display = 'block';
    } else if (tabLabel === 'storage options') {
      const storageBtn = root.querySelector('.view-storage-button-wrapper');
      if (storageBtn) storageBtn.style.display = 'block';
    } else if (tabLabel === 'base strength') {
      const baseBtn = root.querySelector('.view-base-button-wrapper');
      if (baseBtn) baseBtn.style.display = 'block';
    } else if (tabLabel === 'height') {
      const headboardBtn = root.querySelector('.view-base-button-wrapper');
      if (headboardBtn) headboardBtn.style.display = 'block';
    }
    // "Fabric Options" / colours tab has no extra button – nothing to show.
  }

  function setActiveTab(root, index) {
    const tabs = Array.from(root.querySelectorAll('.variant-tab'));
    const panels = Array.from(root.querySelectorAll('[data-fieldset-index]'));
    if (!tabs.length || !panels.length) return;

    if (index < 0 || index >= tabs.length) index = 0;

    tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel) => {
      const panelIndex = Number(panel.dataset.fieldsetIndex);
      const isActive = panelIndex === index;
      panel.hidden = !isActive;
    });

    rememberActiveIndex(root, index);
    updateExtraButtonsForRoot(root, index);
  }

  function initRoot(root) {
    if (!root || root.dataset.variantTabsInit === '1') return;
    root.dataset.variantTabsInit = '1';

    const tabs = Array.from(root.querySelectorAll('.variant-tab'));
    const panels = Array.from(root.querySelectorAll('[data-fieldset-index]'));
    if (!tabs.length || !panels.length) return;

    let index = readRememberedIndex(root, tabs.length);

    if (index == null) {
      const existing = tabs.findIndex((tab) =>
        tab.classList.contains('is-active')
      );
      index = existing >= 0 ? existing : 0;
    }

    setActiveTab(root, index);
    updateAllTabLabels(root);
  }

  function initAll() {
    document.querySelectorAll('variant-selects').forEach(initRoot);
  }

  // 🔹 Global click for any tab (survives DOM replacement)
  document.addEventListener('click', function (event) {
    const tab = event.target.closest('.variant-tab');
    if (!tab) return;

    const root = tab.closest('variant-selects');
    if (!root) return;

    event.preventDefault();

    const index = Number(tab.dataset.optionIndex);
    if (Number.isNaN(index)) return;

    setActiveTab(root, index);
  });

  // 🔹 Global change to update tab text + remember which tab is active before Dawn re-renders
  document.addEventListener('change', function (event) {
    const root = event.target.closest('variant-selects');
    if (!root) return;

    const panel = event.target.closest('[data-fieldset-index]');
    if (panel) {
      const index = Number(panel.dataset.fieldsetIndex);
      if (!Number.isNaN(index)) {
        updateTabLabel(root, index);
      }
    }

    // Remember current active tab so we can restore it after re-render
    const tabs = Array.from(root.querySelectorAll('.variant-tab'));
    const activeIndex = tabs.findIndex((t) => t.classList.contains('is-active'));
    if (activeIndex >= 0) {
      rememberActiveIndex(root, activeIndex);
      updateExtraButtonsForRoot(root, activeIndex);
    }
  });

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor section reload
  document.addEventListener('shopify:section:load', function () {
    initAll();
  });

  // 🔹 Watch for new <variant-selects> when Dawn re-renders product info
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;

        if (node.matches && node.matches('variant-selects')) {
          initRoot(node);
        } else if (node.querySelector) {
          const inner = node.querySelector('variant-selects');
          if (inner) initRoot(inner);
        }
      });
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
